/* Libraries */
import React from 'react';

import Button from '~/src/components/Button';

import {
  getFormattedDateFromIsoString,
  getFormattedTimeFromIsoString,
} from '~/src/utils/date';
import { Small } from '~/src/components/Text';
import Card from '~/src/components/Card';
import styles from '~/src/components/SingleMatterSync/styles';

type SyncSingleMatterProps = {
  handleSync: () => void;
  lastUpdated?: string;
  linkToManage: string;
  cardStyle?: any;
};

const SyncSingleMatter = ({
  handleSync,
  lastUpdated,
  linkToManage,
  cardStyle,
}: SyncSingleMatterProps) => (
  <Card
    elevate={4}
    dynamic
    renderHeader={() => 'Get updates from Clio Manage'}
    cssStyle={cardStyle ?? styles.card}
  >
    {lastUpdated ? (
      <div style={{ marginBottom: 24 }}>
        <Small>
          Last updated {getFormattedDateFromIsoString(lastUpdated)} at{' '}
          {getFormattedTimeFromIsoString(lastUpdated)}
        </Small>
      </div>
    ) : null}

    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Button
        analyticsname="Single Matter Sync - Update now"
        primary
        style={{ marginRight: '18px' }}
        onClick={handleSync}
      >
        Update now
      </Button>
      <a
        style={{ textDecoration: 'underline' }}
        href={linkToManage}
        target="_blank"
        rel="noreferrer"
        analyticsname="Single Matter Sync - View in Clio Manage"
      >
        View in Clio Manage
      </a>
    </div>
  </Card>
);
export default SyncSingleMatter;
